import { AfterViewInit, ChangeDetectorRef, Component, ComponentRef, Input, Type, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { AuthType } from '@core/enums/auth.enum';
import { Subject, takeUntil } from 'rxjs';
import { AuthFacade } from '../auth.facade';
import { UpdateMobileComponent } from '../components/update-mobile/update-mobile.component';

@Component({
	template: '',
})
export class AuthAbstractComponent implements AfterViewInit {
	private readonly cdr = inject(ChangeDetectorRef);
	public readonly authFacade = inject(AuthFacade);

	@Input() authType = AuthType.LOGIN;

	// This is a data used in Logup Component for navigation after success
	// TODO: This should be refactored and do a correct way on how navigation should be
	@Input() navigationData: any;

	@ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;

	localeDirection$ = this.authFacade.localeDirection$;

	loadComponent(component: Type<any>, properties?: any): void {
		this.container.clear();
		const componentRef = this.container.createComponent(component);

		// Set Output events @Output
		this.setCommonOutput(componentRef);

		// Set Translations @Input()
		this.setCommonInput(componentRef, { translations: this.authFacade.getTranslations() });

		// Set Auth type
		if (component !== UpdateMobileComponent) {
			this.setCommonInput(componentRef, { authType: this.authType });
		}

		// Set other Inputs properties
		if (properties) {
			this.setCommonInput(componentRef, properties);
		}

		this.cdr.detectChanges();
	}

	private setCommonOutput<T>(componentRef: ComponentRef<T>): void {
		const ngUnSubscribe = new Subject<void>();

		// Listen to `changed` event or changed screen
		if (componentRef.instance?.['changed']) {
			componentRef.instance['changed'].pipe(takeUntil(ngUnSubscribe)).subscribe((data: any | Type<any>) => {
				if (typeof data === 'object') {
					const { component, ...properties } = data;

					this.loadComponent(component, properties);
				} else {
					this.loadComponent(data);
				}
			});
		}

		// Listen to `handleLoginSuccess` or on successfully login
		if (componentRef.instance?.['handleLoginSuccess']) {
			componentRef.instance['handleLoginSuccess'].pipe(takeUntil(ngUnSubscribe)).subscribe(() => this.authFacade.loginNavigateTo(this.navigationData));
		}

		// Destroy the subscription
		componentRef.onDestroy(() => {
			ngUnSubscribe.next();
			ngUnSubscribe.complete();
		});
	}

	private setCommonInput<T>(componentRef: ComponentRef<T>, properties: any): void {
		// Set `Input` decorators
		Object.entries(properties).forEach(([key, value]) => {
			componentRef.setInput(key, value);
		});
	}

	ngAfterViewInit(): void {
		// To fix the issue on Recaptcha is already created in the login page. When changing locale language.
		setTimeout(() => {
			this.authFacade.initializeRecaptchaVerifier();
		});
	}
}
